/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';

const Shop = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${ApiBaseUrl}/customer/category_list`)
            .then((res) => {
                // console.log(res);
                if (res.data.ResponseCode === 200) {
                    setLoading(false);
                    setCategoryList(res.data.category_list);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const HandleNavigate = (id) => {
        navigate("/shop-list");
        sessionStorage.setItem("Catid", id);
    }

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='width-container pb-[50px] content-wrapper'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="ourservices mt-[20px]">
                        <h1 className='d-title'>{t("Our Category")}</h1>
                        <div className="flex items-center flex-wrap gap-[20px] mt-[20px]">
                            {categoryList.map((item, index) => {
                                return <div onClick={() => HandleNavigate(item.id)} key={index} className='card-box'>
                                    <img className='w-[100%] h-[100px] object-contain mx-auto rounded-[10px]' src={ImgBaseUrl + item.image} alt="" />
                                    <h1 className='font-[500] mt-[10px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                                </div>
                            })}
                        </div>
                    </div>
                </div>}
        </div>
    )
}

export default Shop
/* jshint ignore:end */